// i18n area 'tasks' — locale sq-AL (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.sq-AL.meta.json.
import type { enUS } from './tasks'

export const sqAL: typeof enUS = {
  macrotasks: {
    title: 'Macrotask-et',
    subtitle: 'Operacione të përbëra — të rifillueshme nga hapi i dështuar, ose të ndërpritshme',
    colType: 'Tipi',
    colTarget: 'Objekti',
    colPhase: 'Faza',
    colSteps: 'Hapat',
    empty: 'Asnjë macrotask',
    detail: 'Detajet',
    failedAt: 'dështoi te',
    resume: 'Riprovo nga hapi i dështuar',
    abort: 'Ndërprit gjithçka',
    cancel: 'Anulo',
    actionError: 'Veprimi u refuzua'
  },
  tasks: {
    title: 'Task-et',
    searchPlaceholder: 'Kërko sipas tipit ose target-it',
    type: 'Tipi',
    target: 'Target',
    phaseLabel: 'Faza',
    progress: 'Progresi',
    started: 'Nisur',
    finished: 'Mbaruar',
    node: 'Nyja',
    empty: 'Asnjë task',
    loadError: 'Task-et nuk mund të ngarkohen — a është i arritshëm backend-i TVirt?',
    limboHint: "Nyja '{node}' e paarritshme që nga {time} — task-u e mban write lease mbi target-in e vet derisa nyja të kthehet ose të atestohet e fikur",
    nodeAttested: 'Nyjë e atestuar e fikur',
    phase: {
      queued: 'Në radhë',
      running: 'Në ekzekutim',
      succeeded: 'Përfunduar',
      failed: 'Dështuar',
      cancelled: 'Anuluar',
      'failed-at-step': 'Dështuar në një hap',
      aborted: 'Ndërprerë'
    },
    dropdown: {
      tooltip: 'Task-e në ekzekutim',
      title: 'Task-e në ekzekutim',
      empty: 'Asnjë task në ekzekutim',
      viewAll: 'Shiko të gjithë task-et'
    },
    detail: {
      open: 'Detajet',
      scope: 'Fushëveprimi',
      message: 'Mesazhi',
      params: 'Parametrat',
      result: 'Rezultati',
      errorTitle: 'Gabim',
      steps: 'Hapat',
      failedAt: 'dështoi te',
      superseded: 'i zëvendësuar',

      // Dialog standard (round #156): il posto del figlio nel piano del padre,
      // il padre stesso (apribile in-place) e il passo colpevole.
      step: 'Hapi',
      parent: 'Task-u prind',
      failedStep: 'Hapi i dështuar',
      log: 'Log',
      logEmpty: 'Ende asnjë rresht log-u',
      close: 'Mbyll'
    },
    actions: {
      cancel: 'Anulo',
      resume: 'Riprovo nga hapi i dështuar',
      abort: 'Ndërprit gjithçka (zhbën hapat e përfunduar)',
      refused: 'Veprimi u refuzua'
    }
  },
  events: {
    loadError: 'Ditari nuk u ngarkua dot — a është i arritshëm backend-i i TVirt?',
    title: 'Ngjarje',
    subtitle: 'Kujtesa historike e klasterit: fakte të kryera, nga më e reja',
    filterSeverity: 'Rëndësia',
    filterCategory: 'Kategoria',
    filterAll: 'Të gjitha',
    searchLabel: 'Kërko',
    searchPlaceholder: 'Kërko në të gjithë ditarin',
    subjectFilter: 'Ngjarjet e {subject} — shfaqi të gjitha',
    colAt: 'Kur',
    colSeverity: 'Rëndësia',
    colType: 'Lloji',
    colSubject: 'Subjekti',
    colActor: 'Kush',
    colNode: 'Node',
    colMessage: 'Mesazhi',
    empty: 'Asnjë ngjarje',
    loadMore: 'Ngarko më shumë',
    actorSystem: 'sistemi',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'ID e ngjarjes',
    taskCollectedHint: 'Task ka ruajtje më të shkurtër: pasi mblidhet, lidhja nuk përgjigjet më',
    severity: {
      info: 'Informacion',
      warning: 'Paralajmërim',
      error: 'Gabim',
      critical: 'Kritik'
    },
    category: {
      lifecycle: 'Cikli i jetës',
      config: 'Konfigurimi',
      availability: 'Disponueshmëria',
      security: 'Siguria'
    },
    type: {
      haNetsvcFailedOver: 'Failover i shërbimit të rrjetit',
      haNetsvcNoCandidate: 'Shërbim rrjeti pa nyjë kandidate',
      haNetsvcReaped: 'Instancë lokale e korrur në rikthimin e nyjes',
      netsvcFloatipMoved: 'IP-ja lundruese u zhvendos te një mbajtës tjetër',
      netsvcFloatipNoHolder: 'IP lundruese pa objektiv të shëndetshëm',
      haAppFailedOver: 'Failover i instancës App',
      haAppNoCandidate: 'Instancë App pa nyje kandidate',
      haAppStorageLocalSkip: 'Instanca App nuk u zhvendos: të dhëna të qëndrueshme lokale në nyjen e vdekur',
      haAppReaped: 'Pod-i lokal i instancës App u korr në rikthim'
    }
  },
  audit: {
    loadError: 'Regjistri i auditimit nuk u ngarkua dot — a është i arritshëm backend-i i TVirt?',
    title: 'Auditim',
    subtitle: 'Kush bëri çfarë, kur dhe mbi cilin objekt — veprime të tentuara, përfshirë refuzimet',
    filterOutcome: 'Përfundimi',
    filterAll: 'Të gjithë',
    filterSudo: 'Vetëm veprime të ngritura',
    colAt: 'Kur',
    colActor: 'Kush',
    colAction: 'Veprimi',
    colTarget: 'Objekti',
    colOutcome: 'Përfundimi',
    colNode: 'Node',
    empty: 'Asnjë veprim i regjistruar',
    loadMore: 'Ngarko më shumë',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Rruga',
    detailProblem: 'Arsyeja',
    detailTask: 'Task',
    detailClientIp: 'Nga',
    detailId: 'ID e regjistrimit',
    detailSession: 'Sesioni',
    taskHint: 'Përfundimi i një veprimi të pranuar jeton në ditarin e ngjarjeve, nën të njëjtin id task-u',
    outcome: {
      succeeded: 'Sukses',
      accepted: 'Pranuar',
      denied: 'Mohuar',
      rejected: 'Refuzuar',
      failed: 'Dështuar'
    }
  },
  notifications: {
    loadError: 'Njoftimet nuk u ngarkuan dot — a është i arritshëm backend-i i TVirt?',
    actionError: 'Veprimi u refuzua',
    title: 'Njoftime',
    subtitle: 'Destinacionet drejt të cilave faktet e ditarit dalin nga grupimi',
    rulesTitle: 'Rregulla',
    rulesSubtitle: 'Cilat fakte dalin, dhe drejt ku',
    deliveriesTitle: 'Dërgesa',
    deliveriesSubtitle: 'Rezultati i çdo njoftimi, me arsyen kur dështon',
    colName: 'Emri',
    colKind: 'Lloji',
    colWhere: 'Ku',
    colScope: 'Scope',
    colSeverity: 'Rëndësia',
    colMatch: 'Filtri',
    colTargets: 'Destinacioni',
    colAt: 'Kur',
    colState: 'Gjendja',
    colEvent: 'Ngjarja',
    colAttempts: 'Përpjekje',
    colOutcome: 'Rezultati',
    empty: 'Asnjë rresht',
    matchAll: 'të gjitha faktet',
    test: 'Provo',
    testOk: 'Njoftimi i provës u dërgua te {target}',
    testFailed: 'Prova drejt {target} dështoi: {reason}',
    retry: 'Rikthe në radhë',
    retried: 'Dërgesa u rikthye në radhë',
    grouped: 'dhe {count} përsëritje të tjera',
    state: {
      failed: 'Dështoi',
      pending: 'Në radhë',
      sending: 'Duke u dërguar',
      sent: 'U dërgua'
    },
    tabTargets: 'Destinacione',
    tabRules: 'Rregulla',
    tabDeliveries: 'Dërgesa',
    targetCreateTitle: 'Destinacion i re',
    ruleCreateTitle: 'Rregull i re',
    nameHint: 'Shkronja të vogla, numra dhe vija; unik për çdo fushë',
    kindImmutableHint: 'I pandryshueshëm: ndryshimi i tipit do të thotë krijim i një destinacioni tjetër',
    kindSmtp: 'Postë (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Gjendja',
    enabledOn: 'Aktiv',
    enabledOff: 'I pezulluar',
    smtpHost: 'Serveri SMTP',
    smtpPort: 'Porta',
    smtpPortHint: 'Zakonisht: 25 pa TLS, 587 me starttls, 465 me tls',
    smtpSecurity: 'Siguria',
    smtpFrom: 'Dërguesi',
    smtpTo: 'Marrësit',
    smtpToHint: 'Një ose më shumë adresa të ndara me presje',
    webhookUrl: 'URL',
    payload: 'Përmbajtja',
    payloadHint: 'Me minimal mesazhi dhe të dhënat e eventit nuk largohen nga klasteri',
    credential: 'Kredencial',
    credentialNone: 'Asnjë',
    credentialHintSmtp: 'Llogaria e relay-t nga keystore; asnjë do të thotë SMTP anonim',
    credentialHintWebhook: 'Sekreti i firmës nga keystore; pa firmë, kushdo që di URL-në mund të shtiret si klasteri',
    minSeverityHint: 'Një prag, jo një bashkësi: nga kjo rëndësi e lart',
    categories: 'Kategori',
    categoriesHint: 'Bosh = të gjitha',
    types: 'Tipe eventi',
    typesHint: 'Të ndara me presje; bosh = të gjitha. Një tip i panjohur refuzohet',
    targetsHint: 'Të paktën një; duhet të jenë në fushën e rregullit ose në një paraardhës të tij',
    recursiveOn: 'Edhe fushat bija',
    recursiveOff: 'Vetëm kjo fushë',
    recursiveHint: 'Burimet jetojnë në gjethet: pa bijat, një rregull në rrënjë njofton pothuajse asgjë',
    repeatWindow: 'Dritarja e grupimit (s)',
    repeatWindowHint: 'Brenda dritares përsëritjet nuk dërgojnë postë: numërohen te e para. 0 e çaktivizon',
    targetInUseError: 'Destinacioni {name} përdoret ende nga një rregull'
  }
}
